import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { LOCALE_DE, LOCALE_ES } from '@app/@core/constants/common.constants';
import { DENEGADAS } from '@app/@core/constants/requests.constants';
import {
  BUSINESS_DIRECTOR,
  CHAIN,
  MACRO_CHAIN,
  MACRO_OFFICE,
  OFFICE_DIRECTOR,
} from '@app/@core/constants/users.constants';
import { Credentials } from '@app/@core/models/login-models';
import { CustomValidatorsService } from '@app/@shared/custom-validators/custom-validators.service';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { SelectColumnsComponent } from '@app/@shared/dialogs/select-columns/select-columns.component';
import { LoaderGenericService } from '@app/@shared/loader-generic/loader-generic.service';
import { ExcelService } from '@app/@shared/services/print/excel.service';
import { DatepickerUtilsService } from '@app/@shared/services/utils/datepicker-utils.service';
import { CombosStore } from '@app/requests/combos-service/combos.store';
import { CommonDataDTO } from '@app/requests/model/combos-model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { ActivityStore } from '../activity-services/activity.store';
import { dataPrint, MacroReportRequest, MacroReportResponseDTO } from '../model/activity-model';
import { LoadingExcelComponent } from '@app/@shared/dialogs/loading-excel/loading-excel.component';

const FORM_PARAM_MACRO_CHAIN = 'macroChain';
const FORM_PARAM_MACRO_OFFICE = 'macroOffice';
const FORM_PARAM_ESTABLISHMENT = 'establishment';
const FORM_PARAM_PRESCRIPTOR = 'prescriptor';
const FORM_PARAM_STATUS = 'status';

@UntilDestroy()
@Component({
  selector: 'app-macro',
  templateUrl: './macro.component.html',
  styleUrls: ['./macro.component.scss'],
})
export class MacroComponent implements OnInit {
  public searchDataForm: FormGroup;
  public prescriptorsList: CommonDataDTO[];
  public establishmentsList: CommonDataDTO[];
  public statusList: CommonDataDTO[] = [];
  public macros: MacroReportResponseDTO[] = null;
  macroChainList: CommonDataDTO[] = [];
  macroOfficeList: CommonDataDTO[] = [];
  page: number = 1;
  pageSize: number = 100;
  sizeExcel: number = 15000;

  checkedDateMonth = false;
  maxInitialDate: Date = new Date();
  maxFinalDate: Date = new Date();
  minDate: Date = new Date('1/1/' + (new Date().getFullYear() - 1));
  minInitialDate: Date = new Date('1/1/' + (new Date().getFullYear() - 1));

  isMacroOfficeUser: boolean = false;
  isMacroChainUser: boolean = false;
  isBusinessDirector: boolean = false;

  private isCheckAllPrescriber: boolean = false;
  private isCheckAllEstablishments: boolean = false;

  displayedColumns = [
    'request',
    'chainDesc',
    'startDate',
    'resolutionDate',
    'sectorDesc',
    'teamValue',
    'financeAmount',
  ];
  allColumns = [
    'request',
    'operative',
    'descEstablishment',
    'legalId',
    'businessName',
    'codEstablishment',
    'chainDesc',
    'seller',
    'descSeller',
    'ownId',
    'externalCommercialDesc',
    'proconCod',
    'profinDesc',
    'proconDesc',
    'brandCard',
    'sectorCod',
    'sectorDesc',
    'startDate',
    'cardType',
    'canal',
    'status',
    'contract',
    'statusContract',
    'resolutionDate',
    'cancellationDate',
    'interestDesc',
    'initialTIN',
    'cae',
    'amountCaper',
    'initialTerm',
    'teamValue',
    'entry',
    'financeAmount',
    'transferredAmount',
    'financedAmount',
    'sure',
    'signatureType',
    'tariff',
    'customerNif',
    'customerDesc',
    'indRappel',
    'consumptionRef',
    'vehicleBrand',
    'vehicleModel',
    'registration',
    'embroideryFrame',
    'incentiveAssets',
    'incentiveAssetsPer',
    'incentiveSure',
    'incentiveSurePer',
    'batchPayments',
    'certifiedPayment',
  ];
  excelColumns: string[] = [];

  dataSource = new MatTableDataSource<MacroReportResponseDTO>();

  public head: any[] = [];
  searchParamsExcel: MacroReportRequest;
  private userInfo: Credentials;
  totalPages: number = 0;
  private isPrescriptorLoading: boolean = false;
  private isEstablishmentsLoading: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private customValidators: CustomValidatorsService,
    private translateService: TranslateService,
    private dialog: MatDialog,
    private activityStore: ActivityStore,
    private datePipe: DatePipe,
    private excelService: ExcelService,
    private loaderGenericService: LoaderGenericService,
    private combosStore: CombosStore,
    private datepickerUtils: DatepickerUtilsService
  ) {
    this.excelColumns = this.displayedColumns;
    let dataString: string = localStorage.getItem('credentials');
    this.userInfo = JSON.parse(dataString);
  }

  ngOnInit(): void {
    this.searchDataForm = this.formBuilder.group(
      {
        initialDate: ['', [Validators.required, this.customValidators.checkIsFutureDate]],
        finalDate: ['', [Validators.required, this.customValidators.checkIsFutureDate]],
        status: ['', Validators.required],
        prescriptor: [[''], Validators.required],
        establishment: [[''], Validators.required],
      },
      { validators: [this.customValidators.isDateValid('initialDate', 'finalDate', 'dateInvalid')] }
    );

    this.searchDataForm.controls.initialDate.statusChanges.subscribe((value) => {
      if (value === 'VALID' && value) {
        const initialDateValue = this.searchDataForm.controls.initialDate.value;
        this.minDate = initialDateValue;
      }
    });

    this.searchDataForm.controls[FORM_PARAM_PRESCRIPTOR].valueChanges.subscribe((value) => {
      let prescriptorControl = this.searchDataForm.controls.prescriptor;
      if (value?.length > 0 && !!value[0]) {
        if (prescriptorControl?.enabled) {
          if (this.isCheckAllPrescriber) {
            this.loadEstablishmentCombo();
          } else {
            this.loadEstablishmentComboByPrescribers();
          }
        }
      } else this.resetFormControlAndDataList(FORM_PARAM_ESTABLISHMENT);
    });

    this.validateMacroChainUser();
    if (this.isBusinessDirector) this.initMacroUsers([FORM_PARAM_MACRO_CHAIN, FORM_PARAM_MACRO_OFFICE]);
    else if (this.isMacroChainUser) this.initMacroUsers([FORM_PARAM_MACRO_CHAIN]);
    else if (this.isMacroOfficeUser) this.initMacroUsers([FORM_PARAM_MACRO_OFFICE]);
    else this.loadPrescriptorCombo();

    this.translateService.currentLang === LOCALE_ES ? this.datepickerUtils.spanish() : this.datepickerUtils.catalan();
    this.translateService.onLangChange
      .pipe(untilDestroyed(this))
      .subscribe((event) =>
        event.lang === LOCALE_ES ? this.datepickerUtils.spanish() : this.datepickerUtils.catalan()
      );

    this.loadStatusList();
  }

  changeColumns() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '500px';
    dialogConfig.data = { displayedColumns: this.displayedColumns, allColumns: this.allColumns, disableClose: true };
    const dialog = this.dialog.open(SelectColumnsComponent, dialogConfig);
    dialog
      .afterClosed()
      .toPromise()
      .then((data: any) => {
        if (data) {
          this.displayedColumns = [];
          this.excelColumns = [];
          //solo se muestran los primeros 7 valores seleccionados
          let contador = 0;
          for (let i = 0; i < data.length; i++) {
            const element = data[i];
            if (element.checked) {
              if (contador < 7) {
                this.displayedColumns.push(element.name);
                contador++;
              }
              this.excelColumns.push(element.name);
            }
          }
        }
      });
  }

  exportMacro() {
    this.openDialogLoadingExcel();
    const request: MacroReportRequest = {
      dateFrom: this.datePipe.transform(this.searchDataForm.controls.initialDate?.value, 'yyyy-MM-dd'),
      dateTo: this.datePipe.transform(this.searchDataForm.controls.finalDate?.value, 'yyyy-MM-dd'),
      establishments:
        this.isCheckAllPrescriber && this.isCheckAllEstablishments
          ? []
          : this.searchDataForm.controls.establishment?.value,
      status: this.searchDataForm.controls.status?.value,
      officeId:
        this.isMacroOfficeUser || this.isBusinessDirector ? this.searchDataForm.controls?.macroOffice?.value : null,
      chainId:
        this.isMacroChainUser || this.isBusinessDirector ? this.searchDataForm.controls?.macroChain?.value : null,
      isAllCheck: this.isCheckAllPrescriber && this.isCheckAllEstablishments,
      pageSize: this.sizeExcel,
      pageIndex: 1,
    };
    this.activityStore
      .getMacrosExcel(request)
      .then(
        (result) => {
          result = this.formatNumbers(result);
          if (result && result.length > 0) {
            this.macros = result;
          }
          this.head = [];
          this.head.push(this.allColumns);

          let allDataExcel: dataPrint = { headers: this.head[0], data: this.macros };
          const excelAllData = {
            searchData: this.macros,
            data: allDataExcel,
            dateFrom: this.datePipe.transform(this.searchDataForm.controls.initialDate?.value, 'dd/MM/yyyy'),
            dateTo: this.datePipe.transform(this.searchDataForm.controls.finalDate?.value, 'dd/MM/yyyy'),
            searchStatus: this.statusList.find((status) => status.id === this.searchDataForm.controls.status?.value)
              .value,
          };
          this.excelService.exportExcelMacrosReport(excelAllData);
          this.dialog.closeAll();
        },
        (error) => {
          this.showDialogError(error.error.message);
          this.dialog.closeAll();
        }
      )
      .catch((error) => this.showDialogError(error.error.message));
  }

  public onSearchClick(page: number) {
    const request: MacroReportRequest = {
      dateFrom: this.datePipe.transform(this.searchDataForm.controls.initialDate?.value, 'yyyy-MM-dd'),
      dateTo: this.datePipe.transform(this.searchDataForm.controls.finalDate?.value, 'yyyy-MM-dd'),
      establishments:
        this.isCheckAllPrescriber && this.isCheckAllEstablishments
          ? []
          : this.searchDataForm.controls.establishment?.value,
      status: this.searchDataForm.controls.status?.value,
      officeId:
        this.isMacroOfficeUser || this.isBusinessDirector ? this.searchDataForm.controls?.macroOffice?.value : null,
      chainId:
        this.isMacroChainUser || this.isBusinessDirector ? this.searchDataForm.controls?.macroChain?.value : null,
      isAllCheck: this.isCheckAllPrescriber && this.isCheckAllEstablishments,
      pageSize: this.pageSize,
      pageIndex: this.page,
    };
    this.macros = [];
    this.activityStore
      .getMacros(request)
      .then(
        (result) => {
          result = this.formatNumbers(result);
          if (result && result.length > 0) {
            this.macros = result;
          }
          this.totalPages = result[0].totalPages;
        },
        (error) => this.showDialogError(error.error.message)
      )
      .catch((error) => this.showDialogError(error.error.message))
      .finally(() => (this.dataSource.data = this.macros));
  }

  onClickNavigatePage(page: number) {
    this.page = page;
    this.onSearchClick(page);
  }
  private loadStatusList() {
    this.statusList = [];
    this.activityStore
      .getStatus()
      .then(
        (result) => {
          this.statusList = result;
          this.statusList.map((item) => {
            if (item.id === DENEGADAS) item.value = 'DENEGADAS FINAL';
          });
          if (result?.length > 0) {
            this.statusList = result;
            this.statusList.forEach((item) => {
              if (item.id === DENEGADAS) item.value = 'DENEGADAS FINAL';
            });
            this.statusList.push({ id: '07', value: 'DENEGADAS NO FINAL' });
          }
        },
        (error) => {
          this.statusList = [];
          //mostrar dialog de error
          console.log(error);
          this.showDialogError(error.error.message);
        }
      )
      .catch((error) => this.showDialogError(error.error.message));
  }

  private buildFilterRequest = (filter?: any) => {
    let request;
    if (this.isBusinessDirector) {
      request = this.searchDataForm.controls[FORM_PARAM_MACRO_CHAIN].value
        ? { chainId: this.searchDataForm.controls[FORM_PARAM_MACRO_CHAIN].value, userType: CHAIN }
        : { officeId: this.searchDataForm.controls[FORM_PARAM_MACRO_OFFICE].value, userType: OFFICE_DIRECTOR };
    } else if (this.isMacroChainUser)
      request = { chainId: this.searchDataForm.controls[FORM_PARAM_MACRO_CHAIN].value, userType: CHAIN };
    else if (this.isMacroOfficeUser)
      request = { officeId: this.searchDataForm.controls[FORM_PARAM_MACRO_OFFICE].value, userType: OFFICE_DIRECTOR };
    else request = filter ? filter : {};
    return request;
  };

  private loadPrescriptorCombo = async () => {
    this.loaderGenericService.showSpinner();
    this.isPrescriptorLoading = true;
    this.isEstablishmentsLoading = true;
    this.resetFormControlAndDataList(FORM_PARAM_PRESCRIPTOR);
    const request = this.buildFilterRequest();
    this.combosStore
      .getPrescribers(request)
      .then(
        (result) => {
          if (result?.length > 0) {
            this.prescriptorsList = result;
            this.setValueMultiselect(FORM_PARAM_PRESCRIPTOR, this.prescriptorsList);
          } else this.isEstablishmentsLoading = false;
        },
        (error) => console.error(error)
      )
      .catch((error) => console.error(error))
      .finally(() => {
        this.isPrescriptorLoading = false;
        if (this.isLoadersCompleted()) {
          this.loaderGenericService.stopSpinner();
        }
      });
  };

  private loadEstablishmentCombo = async () => {
    if (!this.isPrescriptorLoading) {
      this.loaderGenericService.showSpinner();
    }
    this.isEstablishmentsLoading = true;
    this.resetFormControlAndDataList(FORM_PARAM_ESTABLISHMENT);
    const request = this.buildFilterRequest();
    this.combosStore
      .getEstablishments(request)
      .then(
        (result) => {
          if (result?.length > 0) {
            this.establishmentsList = result;
            this.setValueMultiselect(FORM_PARAM_ESTABLISHMENT, this.establishmentsList);
          }
        },
        (error) => console.error(error)
      )
      .catch((error) => console.error(error))
      .finally(() => {
        this.isEstablishmentsLoading = false;
        if (this.isLoadersCompleted()) {
          this.loaderGenericService.stopSpinner();
        }
      });
  };

  private loadMacroChains = async () => {
    this.resetFormControlAndDataList(FORM_PARAM_PRESCRIPTOR);
    this.resetFormControlAndDataList(FORM_PARAM_ESTABLISHMENT);
    this.resetFormControlAndDataList(FORM_PARAM_MACRO_CHAIN);
    const promise = this.isBusinessDirector
      ? this.combosStore.getChainsByDivision(this.userInfo.division?.toString())
      : this.combosStore.getChainsFromMacroUser(this.userInfo.userId);
    promise
      .then(
        (data) => {
          if (data) {
            this.macroChainList = [...data];
            if (this.macroChainList.length === 1)
              this.searchDataForm.controls[FORM_PARAM_MACRO_CHAIN].setValue(this.macroChainList[0]?.id);
          }
        },
        (error) => console.error(error)
      )
      .catch((error) => {
        if (error) {
          console.error(error);
          this.showDialogError(error);
        }
      });
  };

  private loadMacroOffices = async () => {
    this.resetFormControlAndDataList(FORM_PARAM_PRESCRIPTOR);
    this.resetFormControlAndDataList(FORM_PARAM_ESTABLISHMENT);
    this.resetFormControlAndDataList(FORM_PARAM_MACRO_OFFICE);
    const promise = this.isBusinessDirector
      ? this.combosStore.getOfficesByDivision(this.userInfo.division?.toString())
      : this.combosStore.getOfficesFromMacroUser(this.userInfo.userId);
    promise
      .then(
        (data) => {
          if (data) {
            this.macroOfficeList = [...data];
            if (this.macroOfficeList.length === 1)
              this.searchDataForm.controls[FORM_PARAM_MACRO_OFFICE].setValue(this.macroOfficeList[0]?.id);
          }
        },
        (error) => console.error(error)
      )
      .catch((error) => {
        if (error) {
          console.error(error);
          this.showDialogError(error);
        }
      });
  };

  private showDialogError(error: string) {
    console.error(error);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '450px';
    dialogConfig.data = { text: error, icon: 'icon-ic_circle_cross' };
    this.dialog.open(ResponseDialogComponent, dialogConfig);
  }

  private validateMacroChainUser = () => {
    this.isMacroChainUser = this.userInfo.userType === MACRO_CHAIN;
    this.isMacroOfficeUser = this.userInfo.userType === MACRO_OFFICE;
    this.isBusinessDirector = this.userInfo.userType === BUSINESS_DIRECTOR;
  };

  private initMacroUsers = (formProperties: string[]) => {
    this.disableFormControls();
    formProperties.forEach((property) => {
      this.searchDataForm.addControl(property, new FormControl('', Validators.required));
      this.initValueChangesMacroUser(property);
      if (property === FORM_PARAM_MACRO_CHAIN) this.loadMacroChains();
      else if (property === FORM_PARAM_MACRO_OFFICE) this.loadMacroOffices();
    });
  };

  private initValueChangesMacroUser = (property: string) => {
    console.log('value changed - macro init');
    this.searchDataForm.controls[property].valueChanges.subscribe((value) => {
      console.log('value changed - macro');
      if (value) {
        this.loadPrescriptorCombo();
        if (this.isBusinessDirector)
          this.disableFormControl(
            property === FORM_PARAM_MACRO_CHAIN ? FORM_PARAM_MACRO_OFFICE : FORM_PARAM_MACRO_CHAIN
          );
        this.enableFormControls();
      } else {
        this.resetFormControlAndDataList(FORM_PARAM_PRESCRIPTOR);
        if (this.isBusinessDirector)
          this.enableFormControl(
            property === FORM_PARAM_MACRO_CHAIN ? FORM_PARAM_MACRO_OFFICE : FORM_PARAM_MACRO_CHAIN
          );
        this.disableFormControls();
      }
    });
  };

  private enableFormControl = (param: string) => {
    if (param) {
      const form = this.searchDataForm.controls;
      if (form[param]?.disabled) form[param].enable();
    }
  };

  private disableFormControl = (param: string) => {
    if (param) {
      const form = this.searchDataForm.controls;
      if (form[param]?.enabled) {
        if (form[param].value) form[param].setValue('');
        form[param].disable();
      }
    }
  };

  private disableFormControls = () => {
    if (this.searchDataForm) {
      Object.keys(this.searchDataForm.controls).forEach((key) => {
        if (key !== FORM_PARAM_MACRO_CHAIN && key !== FORM_PARAM_MACRO_OFFICE) {
          this.searchDataForm.controls[key].reset();
          if (this.searchDataForm.controls[key].enabled) {
            this.searchDataForm.controls[key].disable();
          }
        }
      });
    }
  };

  private enableFormControls = () => {
    if (this.searchDataForm) {
      Object.keys(this.searchDataForm.controls).forEach((key) => {
        if (
          key !== FORM_PARAM_MACRO_CHAIN &&
          key !== FORM_PARAM_MACRO_OFFICE &&
          this.searchDataForm.controls[key].disabled
        ) {
          this.searchDataForm.controls[key].enable();
        }
      });
    }
  };

  sendDateMonth(event: any) {
    if (event.checked === true) {
      this.searchDataForm.controls.initialDate.setValue(moment().startOf('month').format('YYYY-MM-DD'));
      this.searchDataForm.controls.initialDate.disable();
      this.searchDataForm.controls.finalDate.setValue(moment());
      this.searchDataForm.controls.finalDate.disable();
      this.checkedDateMonth = true;
    } else {
      this.searchDataForm.controls.initialDate.reset();
      this.searchDataForm.controls.finalDate.reset();
      this.searchDataForm.controls.initialDate.enable();
      this.searchDataForm.controls.finalDate.enable();
      this.checkedDateMonth = false;
    }
  }

  private resetFormControlAndDataList = (formControlName: string) => {
    const formControl = this.searchDataForm.controls[formControlName];
    if (formControl) {
      formControl.reset();
      switch (formControlName) {
        case FORM_PARAM_MACRO_CHAIN:
          this.macroChainList = [];
          break;
        case FORM_PARAM_MACRO_OFFICE:
          this.macroOfficeList = [];
          break;
        case FORM_PARAM_PRESCRIPTOR:
          this.prescriptorsList = [];
          break;
        case FORM_PARAM_ESTABLISHMENT:
          this.establishmentsList = [];
          break;
        case FORM_PARAM_STATUS:
          this.statusList = [];
          break;
        default:
          console.error('formControlName - NOT FOUND', formControlName);
      }
    }
  };

  private isLoadersCompleted = () => !this.isPrescriptorLoading && !this.isEstablishmentsLoading;

  private loadEstablishmentComboByPrescribers = async () => {
    this.resetFormControlAndDataList(FORM_PARAM_ESTABLISHMENT);
    const request = { listPrescribers: this.searchDataForm.controls.prescriptor?.value };
    if (request) {
      this.combosStore
        .getEstablishmentsByPrescribers(request)
        .then(
          (result) => {
            if (result?.length > 0) {
              this.establishmentsList = result;
              this.setValueMultiselect(FORM_PARAM_ESTABLISHMENT, this.establishmentsList);
            }
          },
          (error) => console.log(error)
        )
        .catch((error) => console.log(error));
    }
  };

  private setValueMultiselect = (formControlName: string, array: CommonDataDTO[]) => {
    if (array?.length > 0) {
      if (array.length === 1) {
        this.searchDataForm.controls[formControlName]?.setValue([array[0]?.id]);
      } else {
        this.searchDataForm.controls[formControlName]?.setValue(array.map((item) => item.id));
      }
    }
  };

  private openDialogLoadingExcel() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '500px';
    dialogConfig.disableClose = true;
    this.dialog.open(LoadingExcelComponent, dialogConfig);
  }

  setCheckAll(check: { id: string; value: boolean }) {
    const { id, value } = check;
    switch (id) {
      case 'prescriptorSelect':
        this.isCheckAllPrescriber = value;
        break;
      case 'establishmentSelect':
        this.isCheckAllEstablishments = value;
        break;
      default:
        console.error('setCheckAll - NOT FOUND:', id);
    }
  }

  private formatNumbers(dto: MacroReportResponseDTO[]): MacroReportResponseDTO[] {
    dto.forEach((element) => {
      element.amountCaper = this.formatNumbersToThousands(parseFloat(element.amountCaper));
      element.entry = this.formatNumbersToThousands(parseFloat(element.entry));
      element.financeAmount = this.formatNumbersToThousands(parseFloat(element.financeAmount));
      element.financedAmount = this.formatNumbersToThousands(parseFloat(element.financedAmount));
      element.incentiveAssets = this.formatNumbersToThousands(parseFloat(element.incentiveAssets));
      element.incentiveSure = this.formatNumbersToThousands(parseFloat(element.incentiveSure));
      element.teamValue = this.formatNumbersToThousands(parseFloat(element.teamValue));
      element.transferredAmount = this.formatNumbersToThousands(parseFloat(element.transferredAmount));
      element.startDate = this.datePipe.transform(element.startDate, 'dd/MM/yyyy');
      element.resolutionDate = this.datePipe.transform(element.resolutionDate, 'dd/MM/yyyy');
      element.cancellationDate = this.datePipe.transform(element.cancellationDate, 'dd/MM/yyyy');
      element.cae = element.cae.replace('.', ',') + '%';
      element.initialTIN = element.initialTIN.replace('.', ',') + '%';
      element.incentiveAssetsPer = element.incentiveAssetsPer.replace('.', ',') + '%';
      element.incentiveSurePer = element.incentiveSurePer.replace('.', ',') + '%';
    });
    return dto;
  }
  private formatNumbersToThousands(value: number): string {
    return new Intl.NumberFormat(LOCALE_DE, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  }
}
